import { styled } from 'styled-components'

export const IntroGradient = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0.1));
`

export const IntroWrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`

export const IntroLogo = styled.img`
  position: relative;
  z-index: 2;
  height: 300px;
  width: 500px;
  object-fit: contain;
  margin-top: 10%;
`

export const IntroText = styled.div`
  position: relative;
  z-index: 2;
  font-size: 162px;
  line-height: 162px;
  max-width: 60%;
  text-align: center;
  margin-bottom: auto;
  margin-top: 10%;
  font-family: ${({ theme }) => theme.font.secondary};
`

export const IntroAction = styled.div`
  position: relative;
  margin-top: auto;
  margin-bottom: 10%;
  z-index: 2;
`

export const IntroBackground = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 0;

  mask-image: linear-gradient(to top, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0) 95%);

  img,
  video {
    object-fit: cover;
    height: 100%;
    width: 100%;
    display: block;
  }
`

export const IntroPoweredBy = styled.div`
  position: relative;
  z-index: 2;
  margin-bottom: 5%;
  display: flex;
  align-items: center;
  gap: 15px;
  cursor: pointer;

  svg {
    height: 60px;
    width: auto;
  }
`
